"use client";
import { jsxs as n, jsx as r } from "react/jsx-runtime";
import { memo as a, forwardRef as m } from "react";
import { useSvgIcon as s } from "../useSvgIcon.js";
const e = a(
  m((l, i) => {
    const { monochrome: o, ...c } = l, t = s({
      ...c,
      ref: i
    });
    return /* @__PURE__ */ n(
      "svg",
      {
        width: 24,
        height: 24,
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t(),
        children: [
          /* @__PURE__ */ r(
            "path",
            {
              d: "M3.90909 26.4991H8.36364V15.6809L2 10.9082V24.59C2 25.6464 2.85591 26.4991 3.90909 26.4991Z",
              fill: o ? "var(--icon-color)" : "#4285F4"
            }
          ),
          /* @__PURE__ */ r(
            "path",
            {
              d: "M23.6364 26.4991H28.0909C29.1473 26.4991 30 25.6432 30 24.59V10.9082L23.6364 15.6809",
              fill: o ? "var(--icon-color)" : "#34A853"
            }
          ),
          /* @__PURE__ */ r(
            "path",
            {
              d: "M23.6364 7.40865V15.6814L30 10.9086V8.36319C30 6.00228 27.305 4.65637 25.4182 6.07228",
              fill: o ? "var(--icon-color)" : "#FBBC04"
            }
          ),
          /* @__PURE__ */ r(
            "path",
            {
              d: "M8.36365 15.6809V7.4082L16 13.1355L23.6364 7.4082V15.6809L16 21.4082",
              fill: o ? "var(--icon-color)" : "#EA4335"
            }
          ),
          /* @__PURE__ */ r(
            "path",
            {
              d: "M2 8.36319V10.9086L8.36364 15.6814V7.40865L6.58182 6.07228C4.69182 4.65637 2 6.00228 2 8.36319Z",
              fill: o ? "var(--icon-color)" : "#C5221F"
            }
          )
        ]
      }
    );
  })
);
e.displayName = "IconGmail";
export {
  e as IconGmail
};
